<template>
  <div class="row">
    <PublicHeader :title="'Bem-vindo ao Dados Abertos'">
      <div class="col-xs-12 col-sm-6">
        <p>
          Dados são abertos quando qualquer pessoa pode livremente usá-los,
          reutilizá-los e redistribuí-los, estando sujeito a, no máximo, a
          exigência de creditar a sua autoria e compartilhar pela mesma licença.
        </p>
        <cite title="Open Knowledge Foundation">
          <a
            href="http://opendatahandbook.org/pt_BR/what-is-open-data/index.html"
            rel="nofollow"
            target="_blank"
          >
            Open Knowledge Foundation
          </a>
        </cite>
      </div>
    </PublicHeader>
    <nav class="panel-nav">
      <div class="container">
        <ul class="text-xl">
          <li>
            <a role="button" @click="scrollToElement('cards-ods')">
              Objetivos do Desenvolvimento Sustentável (ODS)
            </a>
          </li>
          <li>
            <a role="button" @click="scrollToElement('cards-secretaria')">
              Secretarias Municipais
            </a>
          </li>
          <li>
            <a role="button" @click="scrollToElement('cards-portais')">
              Portais de transparência
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <main class="container">
      <div class="row" v-if="favoritos.show">
        <div class="col-xs-12">
          <h2>Favoritos</h2>
          <router-link
            :to="{ name: favoritos.nome_rota }"
            class="text-xl favoritos"
          >
            Acessar meus favoritos
          </router-link>
        </div>
      </div>
      <CardsODS id="cards-ods" :metas="metas" />
      <CardsSecretaria id="cards-secretaria" :secretarias="secretarias" />
      <CardsPortais id="cards-portais" />
      <a
        class="btn-topo"
        role="button"
        v-if="btnTopVisible"
        title="Voltar ao Início"
        @click="scrollToElement('app')"
      >
        <font-awesome-icon :icon="'arrow-up'" />
        <span class="sr-only">Voltar ao topo</span>
      </a>
    </main>
  </div>
</template>

<script>
import {
  PublicHeader,
  CardsODS,
  CardsSecretaria,
  CardsPortais
} from '../../../components'
import { request } from '../../../request'

export default {
  components: {
    PublicHeader,
    CardsODS,
    CardsSecretaria,
    CardsPortais
  },
  data() {
    return {
      metas: [],
      secretarias: [],
      favoritos: {
        titulo: 'Favoritos',
        descricao: 'Favoritos e comparativos',
        nome_rota: 'favoritos',
        show: this.tem_favoritos()
      },
      btnTopVisible: false
    }
  },
  created() {
    this.loadDataFilters()
    window.addEventListener('scroll', this.scrollHandler)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler)
  },
  methods: {
    scrollHandler() {
      const { scrollTop } = document.documentElement
      this.btnTopVisible = scrollTop > 425
    },
    scrollToElement(id) {
      const note = document.getElementById(id)
      const { y } = note.getBoundingClientRect()
      const { scrollTop } = document.documentElement

      window.scrollTo({ top: y + scrollTop - 57, behavior: 'smooth' })
    },
    tem_favoritos() {
      let dados = localStorage.getItem('pmsdadosabertos')
      if (dados) {
        return JSON.parse(dados).favoritos.length > 0
      } else {
        return false
      }
    },
    loadDataFilters() {
      request
        .get('listar-filtros')
        .then(({ data }) => {
          const { metas, secretarias, autarquias } = data
          const todas = {
            nome: 'Todas as Metas',
            titulo: 'Todas as Metas',
            objetivo: 'Exibe a listagem completa de metas',
            cardTodos: true
          }

          this.metas = [...metas, { ...todas }]
          this.secretarias = [
            ...secretarias,
            ...autarquias.map(a => ({ ...a, isAutarquia: true })),
            { ...todas }
          ]
        })
        .catch(e => {
          console.log(e + ' | > dashboard.loadDataFilters:error')
        })
    }
  }
}
</script>

<style scoped>
.favoritos {
  display: inline-block;
  border: 1px solid;
  padding: 5px 10px;
  transition: all 0.2s ease;
}

.favoritos:hover {
  transform: translateY(-3px);
  box-shadow: 0px 0px 5px;
}

nav {
  display: flex;
  z-index: 1;
  margin-top: -15px;
  justify-content: center;
  background-color: #266c16;
  padding: 15px 0;
}
nav ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  padding: 0;
  margin: 0;
}
nav ul > li {
  display: inline-block;
  list-style: none;
}
nav ul > li > a {
  color: #fff;
}
nav ul > li > a:hover {
  color: #a1be4d;
}
.btn-topo {
  position: fixed;
  inset: auto auto 25px 25px;
  border: 1px solid #a1be4d;
  border-radius: 10px;
  height: 60px;
  width: 60px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  z-index: 1;
  box-shadow: 0px 0px 5px;
  background-color: #f8f8f8;
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
  nav {
    position: sticky;
    top: 0;
  }

  .btn-topo {
    inset: auto auto 50px 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/public/painel/index.vue